/** @jsxImportSource @emotion/react */
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Typography,
} from '@mui/material'
import { Section } from '../../../../components'
import { content } from './windsuction.content'
import { styles } from './windzone.styles'

export default function windZoneModal({ isOpen, onClose, ...props }) {
  const modal = content.de.modals.windZone
  return (
    <Dialog fullWidth maxWidth={'sm'} open={isOpen} onClose={onClose} {...props}>
      <DialogTitle>{modal.headline}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Section headline={modal.title}>
            <Typography>{modal.text}</Typography>
          </Section>
          <Section spacing="topSmall">
            <img css={styles.map} src={modal.image} alt={modal.title} />
          </Section>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{content.ui.close}</Button>
      </DialogActions>
    </Dialog>
  )
}
